module.exports = __webpack_public_path__ + "static/media/cloud.74d6186c.svg";